// we display unit of measure in different places and want consistent presentation
// this is a trivial formatting now, but allows for it to be extended later
const formatUOM = (unit: string): string => unit?.toLowerCase() ?? '';

export default formatUOM;
